import Currency from 'currency.js';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { Day } from '../../../models/day.type';
import { TransactionExternalServiceEnum } from '../../transactions/models/transaction-external-service.enum';
import { PromisedPaymentStatusEnum } from './promised-payment-status.enum';

export class PromisedPaymentsFilter extends BaseListFilter {
  userId?: number;
  status?: PromisedPaymentStatusEnum | PromisedPaymentStatusEnum[];
  dealId?: number;
  createdAtFrom?: Date | string;
  createdAtTo?: Date | string;
  dateFrom?: Date;
  dateTo?: Date;
  calculationDateFrom?: Day;
  calculationDateFromAsDate?: Date;
  calculationDateTo?: Day;
  calculationDateToAsDate?: Date;
  effectiveDateFrom?: Date | string;
  effectiveDateTo?: Date | string;
  amountFrom?: Currency;
  amountTo?: Currency;
  isConfirmed?: boolean;
  fetchUser?: boolean;
  fetchDeal?: boolean;
  createdByUser?: boolean;
  createdByAdmin?: boolean;
  fetchOnlyEligibleDeals?: boolean;
  externalService?: TransactionExternalServiceEnum[];
}
